import moment from 'moment';

const monthName = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December',
];
const ProjectionDateUtils = {
  // date conversion
  dateConversion(value) {
    if (value !== '') {
      const fullDate = new Date(value);
      const day = fullDate.getDate();
      const month = fullDate.getMonth();
      const year = fullDate.getFullYear();
      const dateStr = `${`0${day}`.slice(-2)} ${monthName[month].substr(
        0,
        3
      )} ${year.toString().substr(2, 4)}`;
      return dateStr;
    }
  },
  dateOrdinal(day) {
    if (day > 3 && day < 21) return 'th';
    switch (day % 10) {
      case 1:
        return 'st';
      case 2:
        return 'nd';
      case 3:
        return 'rd';
      default:
        return 'th';
    }
  },
  getDaysCount(newOne) {
    const currentDate = moment().format('YYYY-MM-DD');
    const end = moment(newOne);
    const differ = end.diff(currentDate, 'days');
    const dispDate = moment(newOne).date();
    const dispMonth = moment(newOne).month();
    return `${differ} days on the ${`0${dispDate}`.slice(-2)}${this.dateOrdinal(
      dispDate
    )} of ${monthName[dispMonth]}`;
  },
};

export default ProjectionDateUtils;
